import { render } from "./BaseFfsBadge.vue?vue&type=template&id=578ba0e6&scoped=true"
import script from "./BaseFfsBadge.vue?vue&type=script&lang=js"
export * from "./BaseFfsBadge.vue?vue&type=script&lang=js"

import "./BaseFfsBadge.vue?vue&type=style&index=0&id=578ba0e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-578ba0e6"]])

export default __exports__